import { combineReducers } from '@reduxjs/toolkit'
import { configureStore } from '@reduxjs/toolkit'
import LayoutReducer from './layouts/reducer'
import UserReducer from './user/reducer'
import branchReducer from './branchSlice'
import categoriesReducer from './categoriesSlice'
import suppliersReducer from './suppliersSlice'
import productsReducer from './productsSlice'
import purchasesReducer from './purchasesSlice'
import customersReducer from './customersSlice'
import notificationsReducer from './notificationsSlice'
import employeesReducer from './employeesSlice'
import paymentsReducer from './paymentsSlice'
import dashboardReducer from './dashboardSlice'
import expensesReducer from './expensesSlice'
import deliveriesReducer from './deliveriesSlice'
import deliveryZonesReducer from './deliveryZonesSlice'
import driverSettlementsReducer from './driverSettlementsSlice'
import giftCardsReducer from './giftCardsSlice'
import vaultsReducer from './vaultsSlice'
import { offlineMiddleware } from './offlineMiddleware'

const rootReducer = combineReducers({
 Layout: LayoutReducer,
 User: UserReducer,
 branch: branchReducer,
 categories: categoriesReducer,
 suppliers: suppliersReducer,
 products: productsReducer,
 purchases: purchasesReducer,
 customers: customersReducer,
 notifications: notificationsReducer,
 employees: employeesReducer,
 payments: paymentsReducer,
 dashboard: dashboardReducer,
 expenses: expensesReducer,
 deliveries: deliveriesReducer,
 deliveryZones: deliveryZonesReducer,
 driverSettlements: driverSettlementsReducer,
 giftCards: giftCardsReducer,
 vaults: vaultsReducer,
})

export const store = configureStore({
 reducer: rootReducer,
 middleware: (getDefaultMiddleware) =>
 getDefaultMiddleware().concat(offlineMiddleware),
})

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch

export default rootReducer
